import type { SectionKey, CompletenessResponse, SectionStatus } from "@/features/hr/hiring";

export const SECTIONS = [
  { id: "personal_data" as const },
  { id: "contacts" as const },
  { id: "addresses" as const },
  { id: "id_documents" as const },
  { id: "banking" as const },
  { id: "education" as const },
  { id: "experience" as const },
  { id: "bessrochnyi_contract" as const },
  { id: "social_categories" as const },
] as const;

export function getDisabledSteps(completeness: CompletenessResponse | null): SectionKey[] {
  const isPersonalDataComplete = completeness?.sections.personal_data?.complete;
  if (!isPersonalDataComplete) {
    return SECTIONS.filter((s) => s.id !== "personal_data").map((s) => s.id);
  }
  return [];
}

export function getCompletedSteps(
  completeness: CompletenessResponse | null,
  token: string | undefined,
  socialCategoriesWasOpened: boolean,
  getStorageValue: (key: string) => string | null = (key) => localStorage.getItem(key),
): SectionKey[] {
  const completedFromCompleteness = Object.entries(completeness?.sections ?? {})
    .filter(([_, section]) => (section as SectionStatus)?.complete)
    .map(([id]) => id as SectionKey);

  const isSocialCategoriesOpened =
    (token && getStorageValue(`social_categories_opened_${token}`) === "true") || socialCategoriesWasOpened;

  const completedSteps = completedFromCompleteness.filter(
    (id) => id !== "social_categories" || isSocialCategoriesOpened,
  );

  if (isSocialCategoriesOpened && !completedSteps.includes("social_categories")) {
    const socialCategoriesSection = completeness?.sections.social_categories;
    if (socialCategoriesSection?.complete) {
      completedSteps.push("social_categories");
    }
  }

  return completedSteps;
}
